export default function WhyCharterSYG() {
  return (
    <section className="py-24 px-8 lg:px-16 bg-gray-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-20 h-px bg-black mx-auto mb-8"></div>
        <h2 className="font-serif text-4xl md:text-5xl text-black mb-12">
          Why Charter with SYG Yachts
        </h2>
        <div className="space-y-8">
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
            Chartering with SYG Yachts means working with an experienced advisory that understands both the yachts and the expectations of discerning clients. We focus on quality, suitability, and execution — not volume.
          </p>
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
            Our team manages every detail, including yacht selection, itinerary planning, crew coordination, and onboard arrangements, allowing clients to enjoy a seamless and highly personalized charter experience.
          </p>
        </div>
      </div>
    </section>
  );
}
